import { render, staticRenderFns } from "./NavBar.vue?vue&type=template&id=1686d8e7&scoped=true"
import script from "./NavBar.vue?vue&type=script&lang=js"
export * from "./NavBar.vue?vue&type=script&lang=js"
import style0 from "./NavBar.vue?vue&type=style&index=0&id=1686d8e7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1686d8e7",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CommonsNuxtImage: require('/app/components/Commons/NuxtImage.vue').default,Theme4MobileNotificationModal: require('/app/components/Theme4/Mobile/NotificationModal.vue').default,Theme4ComponentsSwitchLanguage: require('/app/components/Theme4/Components/SwitchLanguage.vue').default,Theme4SideNav: require('/app/components/Theme4/SideNav.vue').default,CommonsThemeMode: require('/app/components/Commons/ThemeMode.vue').default})
